import React, { ChangeEvent, FC } from 'react';
import { Box, TextField, TextFieldProps } from '@mui/material';

type PatientsProps = {
    onFilterChange: (searchText: string) => void;
} & TextFieldProps;

const Patients: FC<PatientsProps> = ({ onFilterChange, label, placeholder }: PatientsProps) => {
    const handleFilterChange = (event: ChangeEvent<HTMLInputElement>) => {
        onFilterChange(event.target.value);
    };

    return (
        <Box mb={1}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
                <TextField sx={{ width: 400 }} label={label} placeholder={placeholder} onChange={handleFilterChange} />
            </Box>
        </Box>
    );
};

export default Patients;
